/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import clsx from "clsx";
import ResponsiveEllipsis from "../../partials/content/ResponsiveEllipsis";
import { Link } from "react-router-dom";
export default class SearchResult extends React.Component {
  render() {
    const { data, searchValue } = this.props;
    /*if (!data) {
      return null;
    }

    if (data.length === 0) {
      return (
        <div className="kt-quick-search__result">
          <div className="kt-quick-search__message kt-hidden">
            No record found
          </div>
        </div>
      );
    }*/

    return (
      <React.Fragment>
        {data != null ? (
          <React.Fragment>
            {data.length != 0 ? (
              <React.Fragment>
                <div className="kt-quick-search__result">
                  {data.map((item, index) => (
                    <React.Fragment key={index}>
                      {item.type === 2 && (
                        <Link
                          className="kt-quick-search__item"
                          to={item.url}
                          onClick={() => {
                            document.body.click();
                          }}
                        >
                          <div
                            className={clsx({
                              "kt-quick-search__item-img": item.iconImage,
                              "kt-quick-search__item-icon": item.iconClassName,
                            })}
                          >
                            {item.iconClassName ? (
                              <i className={item.iconClassName} />
                            ) : item.iconImage ? (
                              <img src={item.iconImage} alt="" />
                            ) : null}
                          </div>

                          <div className="kt-quick-search__item-wrapper">
                            <div className="kt-quick-search__item-title">
                              <ResponsiveEllipsis
                                text={item.objectName}
                                maxLine="1"
                              />
                            </div>
                            <div className="kt-quick-search__item-desc">
                              <ResponsiveEllipsis
                                text={item.description}
                                maxLine="1"
                              />
                            </div>
                          </div>
                        </Link>
                      )}

                      {item.type === 1 && (
                        <div className="kt-quick-search__category">
                          <ResponsiveEllipsis
                            text={item.objectName}
                            maxLine="1"
                          />
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="kt-quick-search__result">
                  <div className="kt-quick-search__message kt-hidden">
                    No record found
                  </div>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}
